import {
  TCompanyDetailsListTable,
  TCompanyDetails,
  GeneralObject,
} from '../utils/types';
import { emptySplitApi } from './emptySplitApi';

export const companyDetailService =
  emptySplitApi.injectEndpoints({
    endpoints: (builder) => ({
      getAllCompanyDetails: builder.query<
        TCompanyDetailsListTable[],
        void
      >({
        query: () => ({
          method: 'GET',
          url: `enterprises/country/1`,
        }),
      }),
      getCompanyDetails: builder.query<
        TCompanyDetails,
        string
      >({
        query: (enterpriseName) => ({
          method: 'GET',
          url: `enterprise/search/${enterpriseName}`,
        }),
      }),
      verifyCompany: builder.mutation<
        GeneralObject,
        {
          emailId: string;
          companyName: string;
        }
      >({
        query: (data) => {
          return {
            url: 'enterprise/verify',
            method: 'POST',
            data,
          };
        },
      }),
      addCompanyDetails: builder.mutation<
        GeneralObject,
        GeneralObject
      >({
        query: (data) => {
          return {
            url: 'enterprise/add',
            method: 'POST',
            data,
          };
        },
      }),
      getSearchEnterpriseList: builder.query<
      TCompanyDetails[],
      string
    >({
      query: (searchString) => ({
        method: 'GET',
        url: `enterprises?companyName.contains=${searchString}&page=0&size=10`,
      }),
    }),
    }),
  });

export const {
  useGetAllCompanyDetailsQuery,
  useGetCompanyDetailsQuery,
  useVerifyCompanyMutation,
  useAddCompanyDetailsMutation,
  useGetSearchEnterpriseListQuery,
} = companyDetailService;